import React, { useEffect, forwardRef } from 'react';
import T from 'prop-types';
import cx from 'classnames';
import Slider from 'react-slick';
import { without } from 'lodash-es';

import Modal from '../../../../../components/Modal';

const initConfig = {
  arrows: true,
  dots: false,
  speed: 300,
  centerPadding: 0,
  autoplay: false,
  infinite: true,
  accessibility: true,
  centerMode: true,
  adaptiveHeight: true,
  variableWidth: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  cssEase: 'linear',
};

const SlideModal = forwardRef(({
  open,
  position,
  screenshots,
  loading,
  onChange,
  onAllLoaded,
  onClose,
}, ref) => {
  useEffect(() => {
    document.body.classList.add('no-scroll');

    return () => {
      document.body.classList.remove('no-scroll');
    };
  }, []);

  let allScreenshots = screenshots.map(({ url }) => url);

  const handleImageLoad = (img) => {
    allScreenshots = without(allScreenshots, img.target.src);
    if (open && (allScreenshots.length < 1)) {
      setTimeout(() => {
        onAllLoaded();
      }, 400);
    }
  };

  if (!open) return null;

  const maxWidth = 640;
  const maxHeight = 640;
  const containerWidth = screenshots[position] && screenshots[position].ratio > 1
    ? maxWidth / screenshots[position].ratio
    : maxWidth;
  const containerHeight = screenshots[position] && screenshots[position].ratio > 1
    ? maxHeight
    : maxHeight * (screenshots[position] ? screenshots[position].ratio : 1);

  return (
    <Modal
      open={open}
      modalClassName="screenshot-modal ignore-onclickoutside"
      closeButtonIconClass="hicon-close-2"
      onClose={onClose}
    >
      <div className={cx('screenshot-modal__wrapper', { invisible: loading })}>
        <div
          className="screenshot-modal__main-content"
          style={{
            maxWidth,
            maxHeight,
            width: containerWidth,
            height: containerHeight,
          }}
        >
          <Slider
            {...{ ...initConfig }}
            ref={ref}
            beforeChange={onChange}
          >
            {screenshots.map(shot => (
              <img
                key={shot.url}
                src={shot.url}
                alt="screenshot"
                className="img-fluid"
                onLoad={handleImageLoad}
              />
            ))}
          </Slider>
        </div>
        <div className="screenshot-modal__main-paging">
          {position + 1} of {screenshots.length}
        </div>
      </div>
    </Modal>
  );
});

SlideModal.propTypes = {
  open: T.bool.isRequired,
  position: T.number,
  loading: T.bool,
  screenshots: T.array,
  onChange: T.func.isRequired,
  onAllLoaded: T.func.isRequired,
  onClose: T.func.isRequired,
};

export default SlideModal;
